// import CONFIG from '../modules/config';
import CONFIG from 'GlobalConfigFile';

const server = CONFIG.getRemoteConfig().server;

export function getCurrentUserId() {
  // return 'o0gFU0m-KwkAXiIi2AYnqbRbaVaI';
  return sessionStorage.getItem('userId');
}

export function setCurrentUserId(userId) {
  sessionStorage.setItem('userId', userId);
}

export function getPatientInfo() {
  return JSON.parse(sessionStorage.getItem('patientInfoMap'));
}

export function setPatientInfo(params) {
  sessionStorage.setItem('patientInfoMap', JSON.stringify(params));
}

export function getOrganizationId() {
  // return 'o0gFU0m-KwkAXiIi2AYnqbRbaVaI';
  return sessionStorage.getItem('organizationId');
}

export function setOrganizationId(organizationId) {
  // return 'o0gFU0m-KwkAXiIi2AYnqbRbaVaI';
  sessionStorage.setItem('organizationId', organizationId);
}

export function setToken(token) {
  // _token = token;
  sessionStorage.setItem('token', token);
  return token;
}

export function getToken() {
  return (
    sessionStorage.getItem('token') ||
    'Shufu@dMBe+AlM72rnSnBLx3E3lpgjkZjU8sOm8Z/6xKOf9tOnZWBRlWOB1n4nmAlQ9ugc9Ay/1b6VE2zQkCBe+AlMpWOjf71I1W04fsflx3sj7UEirlR672KMrl/V+2B7mWO2mZKnkCBRmANLE2yslu/4f71I9tlQ9C4nf3lA82N/72rnSWye934Q1WNMf2Osflo692lqE3Oj+3ZnSbaQ1tBL93ZnS/QnZ3Os82lVECBEkCBVm2e/1bcn9qgto/Z497ekEAjg23/B8pBg22yzm/BnmlfR77BF'
  );
  // return 'Shufu@dMBe+AlM72rnSnBLx3E3lpgjkZjU8sOm8Z/6xKOf9tOnZWBRlWOB1n4nmAlQ9ugc9Ay/1b6VE2zQkCBe+AlMpWOjf71I1W04fsflx3sj7UEirlR672KMrl/V+2B7mWO2mZKnkCBRmANLE2yslu/4f71I9tlQ9C4nf3lA82N/72rnSWye934Q1WNMf2Osflo692lqE3Oj+3ZnSbaQ1tBL93ZnS/QnZ3Os82lVECBEkCBVm2e/1bcn9qgto/Z497ekEAjg23/B8pBg22yzm/BnmlfR77BF';
}

export function getServiceInstanceId() {
  // return 'o0gFU0m-KwkAXiIi2AYnqbRbaVaI';
  return sessionStorage.getItem('serviceInstanceId');
}

export function setServiceInstanceId(serviceInstanceId) {
  // return 'o0gFU0m-KwkAXiIi2AYnqbRbaVaI';
  sessionStorage.setItem('serviceInstanceId', serviceInstanceId);
}

export function getServer() {
  return server;
}

export function setCurrentUserInfo(userInfo) {
  sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
}
export function getCurrentUserInfo() {
  return JSON.parse(sessionStorage.getItem('userInfo') || '{}');
}

export function saveFormStatus(messageId, formStatus) {
  try {
    localStorage.setItem(`form_cache_${messageId}`, JSON.stringify(formStatus));
  } catch (e) {
    console.log("saving form state error: ", e);
  }
}

export function deleteFormStatus(messageId) {
  localStorage.removeItem(`form_cache_${messageId}`);
}

export function getFormStatus(messageId) {
  let jsonString = localStorage.getItem(`form_cache_${messageId}`);
  if (jsonString) {
    return JSON.parse(jsonString);
  }
  return null;
}

export function setShowTextToSpeech(showTextToSpeech) {
  return sessionStorage.setItem('showTextToSpeech', showTextToSpeech);
}

export function getShowTextToSpeech() {
  return sessionStorage.getItem('showTextToSpeech');
}

export function setHtmlZoom(htmlZoom) {
  return sessionStorage.setItem('htmlZoom', htmlZoom);
}

export function getHtmlZoom() {
  return sessionStorage.getItem('htmlZoom');
}

export function setServiceItemId(serviceItemId) {
  return sessionStorage.setItem('serviceItemId', serviceItemId);
}

export function getServiceItemId() {
  return sessionStorage.getItem('serviceItemId');
}

export function getSessionId() {
  return sessionStorage.getItem('sessionId');
}

export function setSessionId(sessionId) {
  return sessionStorage.setItem('sessionId', sessionId);
}

export function getDeviceId() {
  return localStorage.getItem('deviceId');
}

export function setDeviceId(deviceId) {
  return localStorage.setItem('deviceId', deviceId);
}

export function getSceneId() {
  return sessionStorage.getItem('sceneId');
}

export function setSceneId(sceneId) {
  return sessionStorage.setItem('sceneId', sceneId);
}

export function getAnnouncement() {
  return sessionStorage.getItem('announcement');
}

export function setAnnouncement(announcement) {
  sessionStorage.setItem('announcement', announcement);
}

export function removeAnnouncement() {
  sessionStorage.removeItem('announcement');
}
export function getShowHistoryReportButton() {
  return sessionStorage.getItem('showHistoryReportButton');
}

export function setShowHistoryReportButton(showHistoryReportButton) {
  sessionStorage.setItem('showHistoryReportButton', showHistoryReportButton);
}
